// Display helpers: names, relative times, UK phone and money formats.
export function fullName(p: { first_name: string; last_name: string; preferred_name?: string | null }): string {
	return `${p.preferred_name || p.first_name} ${p.last_name}`;
}

const rtf = new Intl.RelativeTimeFormat("en-GB", { numeric: "auto" });

export function relativeTime(iso: string | null | undefined, now = Date.now()): string {
	if (!iso) return "Never";
	const diff = (new Date(iso).getTime() - now) / 1000;
	const steps: [number, Intl.RelativeTimeFormatUnit][] = [
		[60, "second"],
		[3600, "minute"],
		[86400, "hour"],
		[604800, "day"],
		[2629800, "week"],
		[31557600, "month"],
	];
	for (const [limit, unit] of steps) {
		if (Math.abs(diff) < limit) {
			const div = unit === "second" ? 1 : (steps[steps.findIndex(([, u]) => u === unit) - 1]?.[0] ?? 1);
			return rtf.format(Math.round(diff / div), unit);
		}
	}
	return rtf.format(Math.round(diff / 31557600), "year");
}

export function dateTime(iso: string): string {
	return new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function telHref(phone: string): string {
	return `tel:${phone.replace(/[^\d+]/g, "")}`;
}

export function countLabel(total: { count: number; capped: boolean }, noun: string): string {
	if (total.count < 0) return "";
	const n = total.capped ? `${total.count.toLocaleString("en-GB")}+` : total.count.toLocaleString("en-GB");
	return `${n} ${noun}${total.count === 1 && !total.capped ? "" : "s"}`;
}

export function longDate(iso: string | null | undefined): string {
	if (!iso) return "";
	return new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso).toLocaleDateString("en-GB", {
		day: "numeric",
		month: "long",
		year: "numeric",
		timeZone: "UTC",
	});
}

/** Opens the phone's messages app; with a body, the text is written for them ("?&body" works on iPhone and Android). */
export function smsHref(phone: string, body?: string): string {
	const to = `sms:${phone.replace(/[^\d+]/g, "")}`;
	return body ? `${to}?&body=${encodeURIComponent(body)}` : to;
}
